import React, { useEffect, useState } from "react";

function Onboarding() {
  return (
    <>
      <p>To-Do's</p>
      <ol>
        <li>Searchable dropdown</li>
        <li>Regilar dropdown</li>
        <li>"Artwork added" form</li>
        <li>Theme picker overlay</li>
      </ol>
      <div
        style={{
          width: "300px",
          display: "flex",
          flexDirection: "column",
          rowGap: "24px",
        }}
      >
        <SearchFont />
        <DropDown />
      </div>
      <Subscribe />
    </>
  );
}

const DropDown = (props) => {
  const items = props.items
    ? props.items
    : [
        "option 1",
        "option 2",
        "option 3",
        "option 4",
        "option 5",
        "option 6",
        "option 7",
        "option 8",
        "option 9",
      ];
  const [selectedItem, setSelectedItem] = useState(undefined);
  const [showOptions, setShowOptions] = useState(false);

  return (
    <div className="dropdown-wrapper">
      <div
        className="dropdown-button-wrapper"
        onClick={() => {
          if (typeof selectedItem !== "undefined") {
            setSelectedItem(undefined);
          }
          setShowOptions((prevState) => {
            return !prevState;
          });
        }}
      >
        <button className={`${showOptions ? "dropdown-open" : ""}`}>
          {selectedItem ? selectedItem : ""}
        </button>
        <img
          className="dropdown-chevron"
          src="/assets/img/onboarding/chevron-down.svg"
        />
      </div>
      <div
        className={`dropdown-results ${
          !selectedItem && showOptions && items?.length > 0 ? "show" : ""
        }`}
      >
        {items.map((item) => {
          return (
            <span
              onClick={() => {
                setSelectedItem(item);
                setShowOptions(false);
              }}
              key={item}
            >
              <input
                style={{ display: "none" }}
                type="radio"
                id={item}
                name={item}
                value={item}
              />
              <label for={item}>{item}</label>
            </span>
          );
        })}
      </div>
    </div>
  );
};

const SearchFont = (props) => {
  const fontList =
    props.fontList?.length > 0
      ? props.fontList
      : ["sans-serif", "'Inter'", "fantasy", "cursive", "serif"];
  const label = props.label ? props.label : "Font";
  const [fontsFound, setFontsFound] = useState([]);
  const [selectedFont, setSelectedFont] = useState(undefined);

  return (
    <div className="search-wrapper">
      <div className="input-wrapper search">
        <label>{label}</label>
        <div className="search-field">
          <input
            type="text"
            name="font-search"
            value={selectedFont ? selectedFont : undefined}
            className={`${fontsFound?.length > 0 ? "items-found" : ""}`}
            onChange={(e) => {
              setSelectedFont(undefined);
              const value = e.target.value.trim();
              const foundFonts =
                value.length > 0
                  ? fontList
                      .filter((font) => font.startsWith(value))
                      .slice(0, 6)
                  : [];
              if (foundFonts?.length > 0) {
                setFontsFound(foundFonts);
              } else {
                setFontsFound([]);
              }
            }}
          />
          <img
            width="15px"
            height="15px"
            className="search-icon"
            src="/assets/img/icons/search.png"
          />
        </div>
      </div>
      {fontsFound?.length > 0 && (
        <div className="search-results">
          {fontsFound.map((font) => {
            return (
              <span
                style={{
                  fontFamily: `${font},sans-serif`,
                }}
                onClick={() => {
                  setSelectedFont(font);
                  setFontsFound([]);
                }}
              >
                {font}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

function Subscribe(props) {
  const { onContinue } = props;
  const [active, setActive] = useState([]);
  const [error, setError] = useState(false);

  const handleSelection = (selection) => {
    if (active.includes(selection)) {
      const newActive = active.filter((item) => item !== selection);
      setActive(newActive);
    } else {
      setActive([...active, selection]);
    }
  };

  const handleContinue = () => {
    if (active.length > 0) {
      onContinue();
    } else {
      setError(true);
    }
  };

  return (
    <div className="subscribe">
      <img
        className="close-subscribe"
        src="/assets/img/onboarding/close.svg"
        onClick={() => {}}
      />
      <div className="subscriptions">
        <div className="header">
          <div className="title">Subscribe</div>
          <div className="demo">
            <label>Want a demo first?</label>
            <button>Book a demo</button>
          </div>
        </div>
        <div className="options">
          <div className="types">
            <span className="selected">Manager</span>
            <span>Website</span>
            <span>Add-Ons</span>
          </div>
          <div className="type-selections">
            <div
              className={`type-selection box box--horz ${"box--active"}`}
              onClick={() => handleSelection("")}
            >
              <div className="box--horz__content">
                <h2>Manager Basic</h2>
                <p>$79/mo | $70/mo (paid annually)</p>
              </div>
              <div className="type-selection-benefits">
                <span>1 User</span>
                <span>1 Location</span>
                <span>1,000 Inventory Works</span>
                <span>1,000 Contacts</span>
                <span>10 Invoices Per Month</span>
                <span>Email Support</span>
              </div>
            </div>
            <div
              className={`type-selection box box--horz`}
              onClick={() => handleSelection("")}
            >
              <div className="box--horz__content">
                <h2>Manager Pro</h2>
                <p>$149/mo | $139/mo (paid annually)</p>
              </div>
              <div className="type-selection-benefits">
                <span>2 User</span>
                <span>1 Location</span>
                <span>5,000 Inventory Works</span>
                <span>10,000 Contacts</span>
                <span>100 Invoices Per Month</span>
                <span>Email Support</span>
              </div>
            </div>
            <div
              className={`type-selection box box--horz`}
              onClick={() => handleSelection("")}
            >
              <div className="box--horz__content">
                <h2>Manager Pro Plus</h2>
                <p>$299/mo | $279/mo (paid annually)</p>
              </div>
              <div className="type-selection-benefits">
                <span>2 User</span>
                <span>1 Location</span>
                <span>5,000 Inventory Works</span>
                <span>10,000 Contacts</span>
                <span>100 Invoices Per Month</span>
                <span>Email Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="total">
        <div className="title">
          <span>Total</span>
        </div>
        <div className="cart">
          <div className="item">
            <label>Manager</label>
            <div className="item-type-price">
              <div className="type">Basic Tier</div>
              <div className="price">$79/mo</div>
            </div>
          </div>
          <div className="item">
            <label>Website</label>
            <div className="item-type-price">
              <div className="type">Pro Tier</div>
              <div className="price">$119/mo</div>
            </div>
          </div>
          <div className="summary">
            <div className="annual-subscription">
              <label className="switch">
                <input type="checkbox" />
                <span className="slider round"></span>
              </label>
              <p>Pay annually to save 15%</p>
            </div>
            <div className="total-price">
              <span>$198/mo</span>
            </div>
            <button>Continue</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Onboarding;
